var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-thumbnail",style:(_vm.style)},[_c('img',{attrs:{"src":_vm.dataUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }